import { call, put, takeEvery } from 'redux-saga/effects';
import {
  getNativeAppConfigSuccess,
  getNativeAppConfigFailure,
} from 'src/Actions/collab/collabActions';

import { forbiddenAccessAction } from 'src/Actions/Subscription/subscriptionAction';
// Constants
import { Collab } from 'src/Actions/collab/types';
import { getNativeAppDetails } from 'src/Services/Collab/collabService';

// Saga handlers
export default function* profileSaga() {
  yield takeEvery(Collab.GET_CONFIG, fetchNativeAppDetails);
}

export function* fetchNativeAppDetails() {
  try {
    let response = yield call(getNativeAppDetails);
      if (response && response.status === 200 && response.data) {
        yield put(getNativeAppConfigSuccess(response.data));
      }
  } catch (e) {
    if (e.status === 403) {
      yield put(forbiddenAccessAction());
    }
    yield put(getNativeAppConfigFailure(e));
  }
}
